/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEffectiveCustomerLimits} from '../api'

 export const useQueryGetEffectiveCustomerLimits = createReactQueryHook('getEffectiveCustomerLimits', getEffectiveCustomerLimits)
